import agendaApiConfig from "./agendaApiConfig";

const ModalidadService = {
  async getAll() {
    return await agendaApiConfig.get("/modalidad");
  },
};

export default ModalidadService;
